import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import EquipmentTypeForm from "components/equipmentTypes/EquipmentTypeForm";
import { updateEquipmentType } from "graphql/mutations";
import { getEquipmentType } from "graphql/queries";
import LoaderFullScreen from "components/utils/LoaderFullScreen";

const EquipmentTypeUpdateForm = ({ equipmentTypeId, onSuccess }) => {
  const navigate = useNavigate();
  const [equipmentType, setEquipmentType] = useState();
  const [loading, setLoading] = useState(false);

  async function onSubmit(valuesParam) {
    try {
      const { name, description, companies } = valuesParam;

      setLoading(true);

      await API.graphql({
        query: updateEquipmentType.replaceAll("__typename", ""),
        variables: {
          input: {
            id: equipmentTypeId,
            name,
            description,
            companies,
          },
        },
      });

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
      else navigate("/equipment-types");
    } catch (err) {
      toast.error(strings.responses[err]);
    } finally {
      setLoading(false);
    }
  }

  async function fetchEquipmentType(id) {
    try {
      const equipmentTypeData = await API.graphql(
        graphqlOperation(getEquipmentType, { id })
      );
      const equipmentTypeItem = equipmentTypeData.data.getEquipmentType;
      if (!equipmentTypeItem) {
        toast.error(strings.responses.errorFetch);
        navigate("/equipment-types");
        return;
      }
      setEquipmentType({
        ...equipmentTypeItem,
      });
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchEquipmentType(equipmentTypeId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [equipmentTypeId]);

  if (!equipmentType) return <Loader />;

  return (
    <div>
      <EquipmentTypeForm
        onSubmit={onSubmit}
        type="update"
        initialValues={equipmentType}
      />
      {loading && <LoaderFullScreen />}
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Tipo de Equipo",
    successUpdated: "Tipo de Equipo actualizado con éxito",
    responses: {
      errorFetch: "Error al consultar el tipo de equipo",
    },
  },
});

export default EquipmentTypeUpdateForm;
